import { Fornitore } from "./Fornitore";

export class Azienda {
    id?: number;
    ragioneSociale?: string;
    indirizzo?: string;
    pIva?: string;
    aziendaCompostaDaAzienda?: Azienda[];
    fornitoriAssociati?: Fornitore[];

    static fromJson(json: any): Azienda {
        let result = new Azienda();
        result.id = json.id;
        result.ragioneSociale = json.ragioneSociale;
        result.indirizzo = json.indirizzo;
        result.pIva = json.pIva;

        if (json.aziendaCompostaDaAzienda) {
            result.aziendaCompostaDaAzienda = json.aziendaCompostaDaAzienda.map((azienda: any) => Azienda.fromJson(azienda));
        }

        if (json.fornitoriAssociati) {
            result.fornitoriAssociati = json.fornitoriAssociati.map((fornitore: any) => Fornitore.fromJson(fornitore));
        }
        return result;
    }
}
